import React, { useState, useEffect, useCallback, useMemo } from "react";
import APIService from "../../Services/API/APIService";
import {
  Table,
  Dimmer,
  Loader,
  Button,
  Dropdown,
  Menu,
  Form,
  Modal,
  Label,
  Pagination
} from "semantic-ui-react";
import dayjs from "dayjs";
import numeral from "numeral";
import CreateBooking from "./CreateBooking";
import { toast } from "react-toastify";
import PaystackDetails from "./PaystackDetails";
import AuditTrails from "./AuditTrails";
import Checkout from "../Checkout/Checkout";
import AddExtraDays from "./AddExtraDays";
import CheckOutDetails from "./CheckOutDetails";
import ApplyDiscount from "./ApplyDiscount";
import ProductTypes from "../../Data/ProductTypes";

const GuestHouseBookings = (props) => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchPhrase, setSearchPhrase] = useState(null);
  const [bookingModalState, toggleBookingModal] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [selectedAudit, setSelectedAudit] = useState(null);
  const [response, setResponse] = useState(null)
  const [paystackModalState, togglePaystackModal] = useState(false);
  const [auditModalState, toggleAuditModal] = useState(false);
  const [extraDaysModalState, toggleExtraDaysModal] = useState(false);
  const [orderModalState, toggleOrderModal] = useState(false);
  const [discountModalState, toggleDiscountModal] = useState(false);
  const [checkoutModalState, toggleCheckoutModal] = useState(null);
  const [extraDays, setExtraDays] = useState(null)
  const [checkoutDetails, setCheckoutDetails] = useState(null)
  const [discountItem, setDiscountItems] = useState(null)
  const [user] = useState(APIService.fetchUser())
  const [payout, setPayout] = useState([])


  const [offset, setOffset] = useState(0);
  const [limit] = useState(50);
  const [rowCount, setRowCount] = useState(0);



  let query = useMemo(() => {
    return {
      offset: offset,
      limit: limit,
    }
  }, [limit, offset])
  const fetchData = useCallback(async (isSubscribed) => {
    try {
      setLoading(true);
      let result = await APIService.getData("/guest-house/getBookings", {
        ...query
      }
    );

      if (isSubscribed) {

        setBookings(result.bookings);
        setRowCount(result.count)
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }, [query])


  useEffect(() => {
    let isSubscribed = true;

    fetchData(isSubscribed);
    return () => (isSubscribed = false);
  }, [bookingModalState, extraDaysModalState, orderModalState, discountModalState, offset, fetchData]);

  const _searchChanged = (e) => {
    setSearchPhrase(e.target.value);
  };


  const checkPayment = async (item) => {
    try {
      if (item.GuestHousePayment?.checkinpaymentMode === "DIRECT_TRANSFER") {
        setLoading(true);
        let response = await APIService.postData(
          `/checkout/checkPayment`,
          { GuestHousePaymentId: item.GuestHousePaymentId, mode: 'checkin' }
        );
        var win = window.open(response?.location, "_blank");
        win.focus();

        setLoading(false);
      } else if (item.GuestHousePayment?.checkinpaymentMode === "PAYSTACK") {
        try {
          setLoading(true);

          let response = await APIService.getData(
            `/checkout/verifyPaystackPayment/`,
            { reference: item.GuestHousePayment?.payReference }
          );
          let payout = await APIService.getData("/checkout/getAllPayout", {

          }
          );

          setPayout(payout)

          setResponse(response)
          togglePaystackModal(true)
          setLoading(false);

        } catch (error) {
          toast.error("Error completing action");
          setLoading(false);
        }

      }
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  const openBookingModal = async (booking) => {
    try {
      setSelectedBooking(booking);
      toggleBookingModal(true);
    } catch (error) {
      console.log("error", error);
    }
  };


  const openAuditModal = async (audit) => {
    try {
      setSelectedAudit(audit);
      toggleAuditModal(true);
    } catch (error) {
      console.log("error", error);
    }
  };

  const openExtraDaysModal = async (item) => {
    try {
      setExtraDays(item);
      toggleExtraDaysModal(true);
    } catch (error) {
      console.log("error", error);
    }
  };
  const _search = async () => {
    setLoading(true);
    try {
      let result = [];
      if (searchPhrase) {
        result = await APIService.getData(`/order/search/${searchPhrase}`);
      } else {
        result = await APIService.getData("/order");
      }
      setLoading(false);
      setBookings(result);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  const approveBooking = async (item) => {
    try {
      setLoading(true);
      await APIService.postData(`/checkout/approveBooking`, item);
      fetchData(true);
      toast.success("Approved successful");
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };


  const cancelBooking = async (item) => {
    try {
      if (window.confirm("Are you sure you want to cancel this Booking?")) {
        setLoading(true);
        await APIService.postData(
          `/checkout/cancel-booking`,
          {
            bookingId: item.id,
            bookingCode: item.bookingId
          }
        );

        toast.success("Cancelled Successful");
        fetchData(true);
      }
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };
  const checkInCustomer = async (item) => {
    try {
      if (window.confirm("Are you sure you want to check In customer?")) {
        setLoading(true);
        await APIService.postData(
          `/guest-house/checkin`,
          {
            GuestHouseBookingId: item.id,
            bookingCode: item.bookingId,
            GuestHousePaymentId: item.GuestHousePaymentId,
            reference: item.reference,
            GuestHouseUserId: item.GuestHouseUserId,
            price: item.GuestHousePackage.price
          }
        );

        toast.success("CheckedIn Successful");
        fetchData(true);
      }
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  const applyDiscount = async (item) => {
    try {

      setDiscountItems(item)
      toggleDiscountModal(true);

    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };



  const openCustomerCheckoutModal = async (booking) => {
    try {

      setCheckoutDetails(booking)
      toggleOrderModal(true);

    } catch (error) {
      console.log("error", error);

    }
  };


  let counter = 0

  const bookingItems = bookings?.map((item) => (

    <Table.Row key={item.id}>

      <Table.Cell> {counter = counter + 1}</Table.Cell>
      <Table.Cell>{item.bookingId}</Table.Cell>
      <Table.Cell>{dayjs(item.createdAt).format("DD-MMM-YYYY")}</Table.Cell>
      <Table.Cell>{item.GuestHousePackage?.name}</Table.Cell>
      <Table.Cell> {item.GuestHouseUser?.email !== ProductTypes.GUESTHOUSE_EMAIL ? item.GuestHouseUser?.firstname + "  " + item.GuestHouseUser?.lastname :
        item.GuestHouseSecretUser?.firstname + " " + item.GuestHouseSecretUser?.lastname}</Table.Cell>
      <Table.Cell> {item.GuestHouseUser?.email !== ProductTypes.GUESTHOUSE_EMAIL ? item.GuestHouseUser?.phoneNumber : item.GuestHouseSecretUser?.phoneNumber}</Table.Cell>
      <Table.Cell>{dayjs(item.checkin).format("DD-MMM-YYYY")}</Table.Cell>
      <Table.Cell>{dayjs(item.checkout).format("DD-MMM-YYYY")}</Table.Cell>
      <Table.Cell>{item.nights}</Table.Cell>
      <Table.Cell>
        ₦{numeral(item.total).format("0,0")}
      </Table.Cell>
      <Table.Cell>

        ₦{numeral(item?.GuestHousePayment?.discountAmount).format("0,0")}
      </Table.Cell>
      <Table.Cell>
        ₦{numeral(item?.GuestHousePayment?.totalPaid).format("0,0")}
      </Table.Cell>
      <Table.Cell>
        <Label
          color={
            item.status === "BOOKED"
              ? "teal"
              : item.status === "APPROVED"
                ? "violet"
                : item.status === "IN_PROGRESS"
                  ? "orange"
                  : "brown"
          }
        >
          {item.status}
        </Label>
      </Table.Cell>

      <Table.Cell>
        <Label color={item.checkedIn ? "teal" : "red"}>
          {item.checkedIn ? "YES" : "NO"}
        </Label>
      </Table.Cell>
      <Table.Cell>      <Label
        onClick={() => checkPayment(item)}
        color={
          item.GuestHousePayment?.checkinpaymentMode === "POS"
            ? "teal"
            : item.GuestHousePayment?.checkinpaymentMode === "DIRECT_TRANSFER"
              ? "violet"
              : item.GuestHousePayment?.checkinpaymentMode === "PAYSTACK"
                ? "olive"
                : item.GuestHousePayment?.checkinpaymentMode === "COOP_SAVINGS"
                  ? "purple"
                  : item.GuestHousePayment?.checkinpaymentMode === "COOP_DEBIT"
                    ? "green"
                    : "brown"
        }
      >
        {item.GuestHousePayment?.checkinpaymentMode === "DIRECT_TRANSFER" ? "TRANSFER" : item.GuestHousePayment?.checkinpaymentMode || "N/A"}
      </Label></Table.Cell>
      <Table.Cell>

        {item.GuestHousePayment?.checkinpaymentMode === 'DIRECT_TRANSFER' || item.GuestHousePayment?.checkinpaymentMode === 'PAYSTACK' ?
          (
            <Label color={
              item?.checkinPayment === true ? "teal" : 'red'
            }>
              {item?.checkinPayment === true ? "Yes" : 'No'}
            </Label>
          )
          :

          (<Label color="brown">
            N/A
          </Label>)


        }

      </Table.Cell>
      <Table.Cell>
        <Dropdown icon="ellipsis vertical" fluid floating pointing="bottom right">
          <Dropdown.Menu>
            {(item.status === "BOOKED") && (
              <Dropdown.Item
                icon="check"
                text="Approve Booking"
                onClick={() => approveBooking(item)}
              />
            )}

            {(item.checkedIn === false && item.status === 'APPROVED') && (
              <>
                <Dropdown.Item
                  icon="calendar check"
                  text="CheckIn Customer"

                  onClick={() => checkInCustomer(item)}
                />
                <Dropdown.Item
                  icon="cut"
                  text="Cancel Booking!"
                  onClick={() => cancelBooking(item)}
                />
              </>
            )}
            {((item.status === "APPROVED" || item.status === "IN_PROGRESS") && item.checkedIn === true && item.checkedOut === false) && (
              <Dropdown.Item
                icon="handshake"
                text="Checkout Customer"
                onClick={() => openCustomerCheckoutModal(item)}
              />
            )}

            {((item.status === "APPROVED" || item.status === "IN_PROGRESS") && item.checkedIn === true && item.checkedOut === false) && (
              <Dropdown.Item
                icon="calendar plus outline"
                text="Add Extra Days"
                onClick={() => openExtraDaysModal(item)}
              />

            )}

            {
              (user?.group[0] === 'SUPERADMIN') && (item.status === "APPROVED" || item.status === "IN_PROGRESS") && (item.checkedIn === true && item.checkedOut === false) && (
                <Dropdown.Item
                  icon="percent"
                  text="Apply Discount"
                  onClick={() => applyDiscount(item)}
                />

              )
            }

            {(item.status === "BOOKED") && (
              <Dropdown.Item
                icon="cut"
                text="Cancel Booking!"
                onClick={() => cancelBooking(item)}
              />
            )}

            {(item.status !== "RESERVED") && (
              <Dropdown.Item
                icon="tasks"
                text="View Audit Trails"
                onClick={() => openAuditModal(item)}
              />
            )}

          </Dropdown.Menu>
        </Dropdown>
      </Table.Cell>
    </Table.Row>
  ));
  return (

    <div style={{ overflowX: 'auto' }}>
      {loading && (
        <Dimmer active inverted>
          <Loader />
        </Dimmer>
      )}


      <Menu secondary stackable>
        <Menu.Item fitted>
          <Button onClick={() => openBookingModal()} style={{ backgroundColor: '#26f09e', color: '#000000' }}>Create Booking</Button>
        </Menu.Item>

        <Menu.Menu position="right">
          <Menu.Item>
            <Form>
              <Form.Input
                placeholder="Name, Email or Phone"
                icon="search"
                onChange={_searchChanged}
                action={{
                  onClick: _search,
                  color: 'teal'
                }}
                disabled
              />
            </Form>
          </Menu.Item>
        </Menu.Menu>
      </Menu>

      {bookings && (
        <Table basic striped celled compact size="small">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>S/N</Table.HeaderCell>
              <Table.HeaderCell>Booking ID</Table.HeaderCell>
              <Table.HeaderCell>Booked Date</Table.HeaderCell>
              <Table.HeaderCell>Package</Table.HeaderCell>
              <Table.HeaderCell>Customer</Table.HeaderCell>
              <Table.HeaderCell>Phone</Table.HeaderCell>
              <Table.HeaderCell>Check In</Table.HeaderCell>
              <Table.HeaderCell>Check Out</Table.HeaderCell>
              <Table.HeaderCell>Nights</Table.HeaderCell>
              <Table.HeaderCell>Amount</Table.HeaderCell>
              <Table.HeaderCell>Discount</Table.HeaderCell>
              <Table.HeaderCell>Paid</Table.HeaderCell>
              <Table.HeaderCell>Status</Table.HeaderCell>
              <Table.HeaderCell>CheckedIn</Table.HeaderCell>
              <Table.HeaderCell>Payment</Table.HeaderCell>
              <Table.HeaderCell>Verified</Table.HeaderCell>
              <Table.HeaderCell></Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>{bookingItems}</Table.Body>
        </Table>
      )}


      <Pagination
        defaultActivePage={1}
        totalPages={Math.ceil(rowCount / limit)}
        onPageChange={(e, { activePage }) =>
          setOffset(1 + (activePage - 1) * limit)
        }
      />
      <Modal
        size="large"
        open={bookingModalState}
        onClose={() => toggleBookingModal(false)}
        closeIcon
      >
        <Modal.Header style={{ color: '#26f09e' }}>{"Create Bookings"}</Modal.Header>
        <Modal.Content>
          <CreateBooking booking={selectedBooking} toggleBookingModal={toggleBookingModal} />
        </Modal.Content>
      </Modal>

      <Modal
        size="small"
        open={checkoutModalState}
        onClose={() => {
          toggleCheckoutModal(false);

        }}
        closeIcon
      >
        <Modal.Header>Payment</Modal.Header>
        <Modal.Content>

          {/* <Checkout email={userEmail} toggleModal={toggleCheckoutModal} purchaseId={PurchaseId} /> */}

          <Checkout toggleModal={toggleCheckoutModal} />
        </Modal.Content>
      </Modal>

      <Modal
        size="small"
        open={orderModalState}
        onClose={() => toggleOrderModal(false)}
        closeIcon
      >
        <Modal.Header>Customers Orders</Modal.Header>
        <Modal.Content>
          <CheckOutDetails booking={checkoutDetails} toggleOrderModal={toggleOrderModal} />
        </Modal.Content>
      </Modal>

      <Modal
        size="small"
        open={paystackModalState}
        onClose={() => togglePaystackModal(false)}
        closeIcon
      >
        <Modal.Header>Paystack Details</Modal.Header>
        <Modal.Content>

          <PaystackDetails receipt={response} payout={payout} />
        </Modal.Content>
      </Modal>


      <Modal
        size="small"
        open={auditModalState}
        onClose={() => toggleAuditModal(false)}
        closeIcon
      >
        <Modal.Header>Audit Trails</Modal.Header>
        <Modal.Content>
          <AuditTrails audit={selectedAudit} />
        </Modal.Content>
      </Modal>


      <Modal
        size="small"
        open={discountModalState}
        onClose={() => toggleDiscountModal(false)}
        closeIcon
      >
        <Modal.Header>Apply Discount</Modal.Header>
        <Modal.Content>
          <ApplyDiscount booking={discountItem} toggleDiscount={toggleDiscountModal} />
        </Modal.Content>
      </Modal>

      <Modal
        size="small"
        open={extraDaysModalState}
        onClose={() => toggleExtraDaysModal(false)}
        closeIcon
      >
        <Modal.Header>Add Extra Days</Modal.Header>
        <Modal.Content>
          <AddExtraDays booking={extraDays} toggleExtraDaysModal={toggleExtraDaysModal} />

        </Modal.Content>
      </Modal>

    </div>


  );
};

export default GuestHouseBookings;
